import React from "react";
import { TAB } from "containers/BudgetHome/PageTabs";
import TabMessages from "containers/BudgetHome/TabMessages";
import SupplementsActionsBar from "./SupplementsActionsBar";
import SupplementList from "./SupplementList";
import BlockList from "./BlockList";
import StructureList from "./StructureList";

const Supplements = (props) => {
    const { online, farm, budget, refData } = props;
    return (
        <React.Fragment>
            <TabMessages farm={farm} budget={budget} tab={TAB.SUPPLEMENTS} />
            <SupplementsActionsBar farm={farm} budget={budget} online={online} />
            <SupplementList online={online} budget={budget} refData={refData} />
            <StructureList farm={farm} budget={budget} refData={refData} />
            <BlockList {...props} />
        </React.Fragment>
    );
};

export default Supplements;
